export const SHARE_PROMPT_MIN_RATING = 4;
export const SHARE_COPY_FEEDBACK_MS = 2000;
